export default "<div class=\"container\">\n\t<div class=\"aboutus_text\">\n<div id=\"html\" class=\"vid-description footerdesc\" ></div>\n</div>\n</div>"